import React, { useState } from 'react';
import './CroppingToolPopup.scss';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../Rodal/Rodal';
import ImageCroppingTool from '../ImageCroppingTool/ImageCroppingTool';

interface CroppingToolPopupProps {
    isVisible: boolean;
    close(): void;
    apply(croppedFile: File, croppedImageUrl: string): void;
    header: string;
    initialAspect?: number;
    preSelectedFile?: File;
}

export const CroppingToolPopup = (props: CroppingToolPopupProps) => {
    const [selectedFile, setSelectedFile] = useState<File>(null);
    const [croppedFile, setCroppedFile] = useState<File>(null);
    const [croppedImageUrl, setCroppedImageUrl] = useState<string>(null);

    const renderButtons = () => {
        const buttons = [];
        if (!selectedFile || croppedImageUrl) {
            buttons.push(
                <button className="cancel-btn" onClick={props.close}>
                    Cancel
                </button>
            );
        }
        if (croppedImageUrl) {
            buttons.push(
                <button
                    className="reset-btn"
                    onClick={() => {
                        setCroppedImageUrl(null);
                        setCroppedFile(null);
                    }}>
                    Reset Result
                </button>
            );
            buttons.push(
                <button
                    className="apply-result-btn"
                    onClick={() => {
                        props.apply(croppedFile, croppedImageUrl);
                        props.close();
                    }}>
                    Apply Result
                </button>
            );
        }

        return buttons.length ? (
            <div className="buttons-wrapper">{buttons.map((b) => b)}</div>
        ) : (
            <></>
        );
    };

    return (
        <div className="cropping-tool-popup">
            <Rodal
                visible={props.isVisible}
                onClose={() => props.close()}
                width={500}
                showMask={false}>
                <ModalHeader>{props.header}</ModalHeader>
                <ModalBody>
                    {croppedImageUrl ? (
                        <div className='cropped-image-container'>
                            <img
                                className="cropped-image"
                                src={croppedImageUrl}></img>
                        </div>
                    ) : (
                        []
                    )}
                    <div style={croppedImageUrl ? { display: 'none' } : {}}>
                        <ImageCroppingTool
                            initialAspect={props.initialAspect}
                            preSelectedFile={props.preSelectedFile}
                            selectedFile={selectedFile}
                            setSelectedFile={setSelectedFile}
                            close={props.close}
                            setCroppedFile={setCroppedFile}
                            setCroppedImageUrl={
                                setCroppedImageUrl
                            }></ImageCroppingTool>
                    </div>
                    {renderButtons()}
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default CroppingToolPopup;
